const LocalStorageManager = class {
  constructor() {
    this._storage = window.localStorage // iOS 에서 웹뷰간 유지 안됨
  }

  get(key) {
    let item

    try {
      item = JSON.parse(this._storage.getItem(key))
    } catch (e) {}

    return item
  }

  set(key, value) {
    this._storage.setItem(key, JSON.stringify(value))
  }

  remove(key) {
    this._storage.removeItem(key)
  }
}

export default LocalStorageManager
